import { listRecords, createRecord, updateRecord, deleteRecord, uploadMedia, mediaUrl, MEDIA_BUCKET } from './supabase';
import { ministryInputToISO as toISO } from '../utils/ministryDates';
async function eventValues(eventData) {
    const payload = { ...eventData };
    delete payload.image;
    delete payload.id;
    delete payload.$id;
    if (eventData.image) payload.imageId = (await uploadMedia(MEDIA_BUCKET, eventData.image)).id;
    if ('startDate' in payload) payload.startDate = toISO(payload.startDate);
    if ('endDate' in payload) payload.endDate = toISO(payload.endDate);
    return payload;
}
export const eventUtils = {
    async getEvents() {
        return (await listRecords('events', { order: 'startDate', ascending: true })).map(row => ({
            ...row, imageUrl: mediaUrl(MEDIA_BUCKET, row.imageId),
        }));
    },
    async createEvent(data) { return createRecord('events', await eventValues(data)); },
    async updateEvent(id, data) { return updateRecord('events', id, await eventValues(data)); },
    deleteEvent: id => deleteRecord('events', id),
};
